import { render } from "./Lobby.vue?vue&type=template&id=5e2309a9&scoped=true"
import script from "./Lobby.vue?vue&type=script&lang=js"
export * from "./Lobby.vue?vue&type=script&lang=js"

import "./Lobby.vue?vue&type=style&index=0&id=5e2309a9&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e2309a9"]])

export default __exports__